// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Bw3P-","col":"styles_col__GgpPb"};